<template>
    <div class="convenios-container">
        <h2>Convenios</h2>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <div slot="header">
                        <span>Gestión de Convenios</span>
                    </div>
                    <div>
                        Contenido de Convenios
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'BotConvenios',
    data() {
        return {
            token: this.$route.query.token
        }
    }
}
</script>

<style lang="scss" scoped>
.convenios-container {
    padding: 20px;
}
</style> 